import { stringify } from 'qs'

export class Cms {
  // src - the full url to load
  // waitForPageLoad - still wait for the page load event on first hit
  constructor ($axios) {
    this.$axios = $axios
  }

  get (url, options) {
    return this.$axios.$get(
      url, {
        ...options,
        // modify auth header for current request only
        transformRequest: (data, headers) => {
          // prevent the header from being added by default
          delete headers.common.Authorization
          // some libraries might set it directly as well, e.g. nuxtjs/auth
          delete headers.Authorization
          return data
        },
        paramsSerializer: params => stringify(params, { encode: false })
      })
  }
}
